import React, { useState } from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import CurateDataCont from "./CurateDataCont";
import { FiPlusCircle } from "react-icons/fi";
import ConfigureProductDataCount from "./ConfigureProductDataCount";
const CurateDataTable = () => {
  document.title = "Configure Product";
  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [showSampleFile, setShowSampleFile] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [SearchItem, setSearchItem] = useState('');
  const [newRecord, setNewRecord] = useState({
    ProductUniqueName: '',
    ProductGroup: '',
    CASNo: "",
    Part: "",
    MainATCCategory: "",
    SubCategory1: "",
    SubCategory2: "",
    SubCategory3: ""
  });
  const closeModal = () => {
    setAddModalOpen(false);
    setNewRecord({
      ProductUniqueName: '',
      ProductGroup: '',
      CASNo: "",
      Part: "",
      MainATCCategory: "",
      SubCategory1: "",
      SubCategory2: "",
      SubCategory3: ""
    });
    setError("");
  };
  const openAddModal = () => {
    setAddModalOpen(true);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '60%', marginTop: 8 }}>
                    <form style={{ width: "100%", marginBottom: 12 }}>
                      <input
                        type="text"
                        value={searchQuery}
                        placeholder="Type here to search"
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{ width: "100%" }}
                      />
                    </form>
                    <h6 className="mb-2" style={{ fontSize: 20, whiteSpace: 'nowrap' }}>
                      Total Record: {totalItems}
                    </h6>
                  </div>
                  <button
                    onClick={openAddModal}
                    style={{
                      padding: '7px 20px',
                      backgroundColor: "#4b38b3",
                      height: 40,
                      display: 'flex',
                      alignItems: 'center',
                      color: 'white',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                  >
                    <FiPlusCircle style={{ fontSize: 20, marginRight: 5 }} />
                    Add Record
                  </button>
                </CardHeader>

                <CardBody>
                  <ConfigureProductDataCount
                    setTotalItems={setTotalItems}
                    totalItems={totalItems}
                    isAddModalOpen={isAddModalOpen}
                    setAddModalOpen={setAddModalOpen}
                    closeModal={closeModal}
                    setError={setError}
                    newRecord={newRecord}
                    setNewRecord={setNewRecord}
                    searchQuery={searchQuery}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CurateDataTable;
